import { Link } from 'react-router-dom';
import { dailyUpdates } from '@/mocks/home';

export default function DailyUpdatesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 text-primary-400 text-xs font-medium mb-4">
              <i className="ri-timer-flash-line text-sm"></i>
              每日更新
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50">
              最新<strong className="text-primary-500">黑料</strong>曝光
            </h2>
            <p className="mt-2 text-sm text-foreground-400">今日最新上线的<strong>独家爆料</strong>内容</p>
          </div>
          <Link
            to="/category/exclusive"
            className="flex items-center gap-1 text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {dailyUpdates.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className={`group bg-background-50 rounded-lg overflow-hidden border border-background-200/40 hover:border-primary-500/30 transition-all duration-300 cursor-pointer ${
                index === 0 ? 'lg:col-span-2 xl:col-span-2' : ''
              }`}
            >
              {/* Image */}
              <div className={`relative overflow-hidden ${index === 0 ? 'h-52' : 'h-40'}`}>
                <img
                  src={article.image}
                  alt={`51黑料网 - ${article.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  title={article.title}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded text-[10px] font-medium bg-primary-500/80 text-foreground-50">
                  {article.category}
                </span>
              </div>

              {/* Content */}
              <div className="p-4">
                <h3 className={`font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors duration-200 line-clamp-2 ${
                  index === 0 ? 'text-base' : 'text-sm'
                }`}>
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {(article.views / 1000).toFixed(1)}k
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
